import React from 'react';
import classNames from 'classnames';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { Colors } from '@lib/enums/colors';
import styles from './IconSurface.module.scss';

export type IconSurfaceShape = 'circle' | 'rounded' | 'square';
export type IconSurfaceSize = 'sm' | 'md' | 'lg';

export type IconSurfaceProps = {
  className?: string;
  color?: Colors;
  icon: string;
  iconClassName?: string;
  shape?: IconSurfaceShape;
  size?: IconSurfaceSize;
  surfaceClassName?: string;
  symbolsOutlined?: boolean;
};

const iconFontSizeByContainer: Record<IconSurfaceSize, string> = {
  sm: 'md-16',
  md: 'md-20',
  lg: 'md-24',
};

export default function IconSurface(props: IconSurfaceProps) {
  const {
    className,
    color = Colors.Blue,
    icon,
    iconClassName,
    shape = 'circle',
    size = 'lg',
    surfaceClassName,
    symbolsOutlined,
  } = props;

  return (
    <div className={classNames(styles.surface, styles[size], className)}>
      <div>
        <div
          className={classNames(
            styles[shape],
            styles[size],
            styles[color],
            surfaceClassName,
          )}
        />
      </div>
      <div>
        <MaterialIcon
          icon={icon}
          size={iconFontSizeByContainer[size]}
          symbolsOutlined={symbolsOutlined}
          className={classNames(styles[color], iconClassName)}
        />
      </div>
    </div>
  );
}
